import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const reportCategory = {
    path: '/report-category',
    component: Layout,
    name: 'reportCategory',
    redirect: '/report-category/index',
    children: [
        {
            path: '/report-category/index',
            component: () => import('@/views/reportCategory/index'),
            name: 'reportCategory.index',
            meta: { title: i18n.t(`message.reports`) },
        },
        {
            path: "",
            component: () => import("@/views/reportCategory/_slug"),
            name: "reportCategory.slug",
            meta: { title: "slug" },
            children: [
                {
                    path: '/report-category/report/report-doctors',
                    component: () => import('@/views/report/report-doctors'),
                    name: 'reportDoctors/index',
                    meta: { title: i18n.t(`message.doctor_reports`) }
                },
                {
                    path: '/report-category/partnerDoctorReport/index',
                    component: () => import('@/views/partnerDoctorReport/index'),
                    name: 'partnerDoctorReport.index',
                    meta: { title: i18n.t(`message.partner_doctor_reports`) }
                },
                {
                    path: '/report-category/partnerClinicReport/index',
                    component: () => import('@/views/partnerClinicReport/index'),
                    name: 'partnerClinicReport.index',
                    meta: { title: i18n.t(`message.partner_clinic_reports`) }
                },
                {
                    path: '/report-category/insuranceCompanyReport/index',
                    component: () => import('@/views/insuranceCompanyReport/index'),
                    name: 'insuranceCompanyReport.index',
                    meta: { title: i18n.t(`message.invoice_companies_report`) }
                },
                {
                    path: '/report-category/paymentReport/index',
                    component: () => import('@/views/paymentReport/index'),
                    name: 'paymentReport.index',
                    meta: { title: i18n.t(`message.payment_reports`) }
                },
                {
                    path: '/report-category/patientResidenceReport/index',
                    component: () => import('@/views/patientResidenceReport/index'),
                    name: 'patientResidenceReport.index',
                    meta: { title: i18n.t(`message.patient_residence_reports`) }
                },
                {
                    path: '/report-category/patientServiceReport/index',
                    component: () => import('@/views/patientServiceReport/index'),
                    name: 'patientServiceReport.index',
                    meta: { title: i18n.t(`message.patient_service_reports`) }
                },
                {
                    path: '/report-category/dailyProcessReport/index',
                    component: () => import('@/views/dailyProcessReport/index'),
                    name: 'dailyProcessReport.index',
                    meta: { title: i18n.t(`message.reports`) }
                },
                {
                    path: '/report-category/doctorProcessReport/index',
                    component: () => import('@/views/doctorProcessReport/index'),
                    name: 'doctorProcessReport.index',
                    meta: { title: i18n.t(`message.reports`) }
                },
                {
                    path: '/report-category/excelReports/index',
                    component: () => import('@/views/excelReport/index'),
                    name: 'excelReports.index',
                    meta: { title: i18n.t(`message.excel_reports`) }
                },
            ]
        }
    ]
}
export default reportCategory